import { useDispatch } from "react-redux";
import { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import "./SuiteDashboard.scss";
import Login from "../LoginPage/Login";
import { useNavigate } from 'react-router-dom';

/**
 * SuiteDashboard Component
 *
 * @component
 * @description
 * Displays a dashboard for user to navigate between Access Point applications.
 *
 * @returns {JSX.Element} The Suite dashboard UI.
 *
 * @example
 * // Usage:
 * <SuiteDashboard />
 */
export default function SuiteDashboard() {

const handleClick = () => {
    navigate('');
  }
 
 
  useEffect(() => {
    // Get body element and add class on mount
    document.body.classList.add("suite-dashboard-active");

    return () => {
      // Cleanup: Remove the class when the component unmounts
      document.body.classList.remove("suite-dashboard-active");
    };
  }, []); // run once, on mount and cleanup on unmount

  const navigate = useNavigate();

  const isLoggedIn = useSelector((state) => state.user.isAuthenticated);

  if (!isLoggedIn) {
    return (
      <div data-testid="SuiteDashboard" style={{height: "100%"}}>
        <Login />
      </div>
    );
  }
  return (
    /*"suite-dashboard-container" class includes header and footer*/
    <div data-testid="SuiteDashboard" className="suite-dashboard-container">
      {/* ticket system button */}
      <div className="outer-line" onClick={handleClick}>
        <div data-testid="ticket-system-block" className="inner-content">
          <svg className="ticket-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 -1 24 22" fill="none" id="IconChangeColor" height="200" width="200" stroke-width="1."><path fill="#ffffff" stroke="#000000" fill-rule="evenodd" d="M16 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a1 1 0 1 1 2 0h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2a1 1 0 1 1-2 0zm1 5.001a1 1 0 0 0 1-1V8a1 1 0 1 0-2 0v.001a1 1 0 0 0 1 1zm1 3a1 1 0 1 1-2 0V12a1 1 0 1 1 2 0v.001zm-1 5a1 1 0 0 0 1-1V16a1 1 0 1 0-2 0v.001a1 1 0 0 0 1 1zM6 11a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H6zm0 4a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2H6z" clip-rule="evenodd" id="mainIconPathAttribute"></path></svg>

          <a
              href="/Tickets"
              aria-label="Access Point Ticket System"
              target="_self"
              rel="noopener noreferrer"
              data-testid="ticket-system-link"
              className="redirect-link"
            >
              Ticket System
            </a>
        </div>
      </div>
      { <div className="outer-line">
        <div data-testid="library-suite-block" className="inner-content">
          <svg className="book-icon" xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 -3.5 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-book-open" id="IconChangeColor">
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" id="mainIconPathAttribute" stroke="#000000" stroke-width="1" />
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" id="mainIconPathAttribute" stroke="#000000" stroke-width="1" />
          </svg>

          <a
            href="/Library"
            aria-label="Access Point Library Suite"
            target="_self"
            rel="noopener noreferrer"
            data-testid="library-suite-link"
            className="redirect-link"
          >
            Library Suite
          </a>
        </div>
      </div> }
       {/* career plan button, leave this here to make yad's and c6 life easier */}
      {/* <div className="outer-line">
        <div data-testid="career-plan-block" className="inner-content">
          <svg className="briefcase-icon" xmlns="http://www.w3.org/2000/svg" width="200" height="200" fill="#000000" class="bi bi-briefcase" viewBox="0 -2 16 16" id="IconChangeColor"> 
            <path d="M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v8A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-8A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1h-3zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V7.15l6.614 1.764a1.5 1.5 0 0 0 .772 0zM1.5 4h13a.5.5 0 0 1 .5.5v1.616L8.129 7.948a.5.5 0 0 1-.258 0L1 6.116V4.5a.5.5 0 0 1 .5-.5z" id="mainIconPathAttribute"/>
          </svg>

          <a
            href="put career plan link here"
            aria-label="Access Point Career Plan"
            target="_self"
            rel="noopener noreferrer"
            data-testid="career-plan-link"
            className="redirect-link"
          >
            Career Plan
          </a>
        </div>
      </div> */}
      {/* score card button, leave this here to make yad's and c6 life easier */}
      {/* <div className="outer-line">
        <div data-testid="score-card-block" className="inner-content">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="-10 -75 630 512" id="IconChangeColor" height="200" width="200"><path d="M512 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h448c35.35 0 64-28.65 64-64V96C576 60.65 547.3 32 512 32zM176 128c35.35 0 64 28.65 64 64s-28.65 64-64 64s-64-28.65-64-64S140.7 128 176 128zM272 384h-192C71.16 384 64 376.8 64 368C64 323.8 99.82 288 144 288h64c44.18 0 80 35.82 80 80C288 376.8 280.8 384 272 384zM496 320h-128C359.2 320 352 312.8 352 304S359.2 288 368 288h128C504.8 288 512 295.2 512 304S504.8 320 496 320zM496 256h-128C359.2 256 352 248.8 352 240S359.2 224 368 224h128C504.8 224 512 231.2 512 240S504.8 256 496 256zM496 192h-128C359.2 192 352 184.8 352 176S359.2 160 368 160h128C504.8 160 512 167.2 512 176S504.8 192 496 192z" id="mainIconPathAttribute" fill="#ffffff" stroke="#000000" stroke-width="20" />
          </svg>

          <a
            href="put score card link here"
            aria-label="Access Point Score Card"
            target="_self"
            rel="noopener noreferrer"
            data-testid="career-plan-link"
            className="redirect-link"
          >
            Score Card
          </a>
        </div>
      </div>  */}
    </div>

  );
}
